import { CollapsibleSection } from '@pmai/ui';
import type { ReactNode } from 'react';
import { useCollapsed } from './use-collapsed';

/**
 * A card section whose open/closed state is remembered in this browser for every card of the same
 * kind (FR-PRJ-016) — `id` is e.g. `project.notes`, not the record.
 */
export function CardSection({
  id,
  title,
  actions,
  children,
}: {
  id: string;
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const [open, toggle] = useCollapsed(id);
  return (
    <CollapsibleSection
      id={id.replace(/\W/g, '-')}
      title={title}
      open={open}
      onToggle={toggle}
      actions={actions}
    >
      {children}
    </CollapsibleSection>
  );
}
